import Component from "@glimmer/component";
import { LinkTo } from "@ember/routing";
import { service } from "@ember/service";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

export default class ChatNavbarClosePinsButton extends Component {
  @service site;

  closeButtonTitle = i18n("chat.pinned_messages.close");

  <template>
    {{#if this.site.desktopView}}
      <LinkTo
        class="c-navbar__close-pins-button btn-transparent btn btn-icon no-text"
        title={{this.closeButtonTitle}}
        @models={{@channel.routeModels}}
        @route="chat.channel"
      >
        {{dIcon "xmark"}}
      </LinkTo>
    {{/if}}
  </template>
}
